import Axios from 'axios';
import React from 'react';

import { getToken } from '../keycloak';

const InterceptorAxios = ({ children }) => {
    const token = getToken();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [loaded, setLoaded] = React.useState();

    const clearState = () => {
        setError();
        setLoading();
    };

    React.useEffect(() => {
        Axios.interceptors.request.use(
            (config) => {
                config.headers.Authorization = `Bearer ${token}`;
                setLoading(true);
                return config;
            },
            (error) => {
                setError(error);
                setLoading(false);
                return Promise.reject(error);
            },
        );

        Axios.interceptors.response.use(
            (response = {}) => {
                setLoading(false);

                const status = response.status;

                switch (true) {
                    case status === 400:
                    case status === 401:
                    case status === 403:
                    case status === 404:
                    case status === 415:
                    case status >= 500 && status <= 599:
                        setError(status);
                        return response;
                    default:
                        return response.data;
                }
            },
            (error) => {
                setError(error);
                setLoading(false);
                return Promise.reject(error);
            },
        );
        setLoaded(true);
    }, [token]);

    return loaded ? children({ error, loading, clearState }) : null;
};

export default InterceptorAxios;
